export default __webpack_public_path__ + "static/clue-38a35c98187a04069eb5f71650059fc5.png";